export default "__VITE_ASSET__ibHI_gBM__"